import { graphql, useMutation } from "react-relay";
import { useWorkspaceTodoEditRemoveImagesMutation } from "./__generated__/useWorkspaceTodoEditRemoveImagesMutation.graphql";
import { useCallback } from "react";

export function useWorkspaceTodoEditRemoveImages() {
  const [removeImageMutation] =
    useMutation<useWorkspaceTodoEditRemoveImagesMutation>(graphql`
      mutation useWorkspaceTodoEditRemoveImagesMutation(
        $todoWorkspaceId: ID!
        $imageIds: [ID!]!
      ) {
        todoWorkspace(id: $todoWorkspaceId) {
          removeImages(imageIds: $imageIds) {
            id
            ...WorkspaceTodoEditMainEditedInfo_Todo
            descriptionImages {
              id
            }
          }
        }
      }
    `);

  return useCallback(
    (todoWorkspaceId: string, imageIds: string[]) => {
      return removeImageMutation({
        variables: {
          todoWorkspaceId,
          imageIds,
        },
      });
    },
    [removeImageMutation]
  );
}
